import { isClientAccountType } from "@/constants/accountTypes";
import { useAppSelector } from "@/redux/hooks";
import { profileSelector } from "@/redux/slices/profile/selectors";
import { NotFound } from "./NotFound";

/**
 * The catch-all 404 for the operator dashboard.
 *
 * Clients have no page of their own in this app, so the only way they reach it is by typing a
 * dashboard URL (or following a stale link). Dropping them into the operator shell shows them a
 * sidebar of things they can't use and no way to sign out, so they get a standalone 404 with a
 * logout button instead.
 *
 * The client check is an ALLOWLIST of account types: operators, user accounts, drivers, and any
 * type we don't recognise all fall through to the operator 404 exactly as before. That direction
 * matters — `accountType` is null for every non-client account, so anything we can't positively
 * identify as a client keeps its existing behaviour.
 *
 * Admin levels (Owner / Admin / Manager / Dispatcher / Call Center / Fa_Access) are per-operator
 * ROLES, not account types — they never appear in this field and can't match the allowlist.
 */
export const DashboardNotFound = () => {
  const profile = useAppSelector(profileSelector);

  if (isClientAccountType(profile?.accountType)) {
    return <NotFound overlay headerAction="logout" />;
  }

  return <NotFound noHeader />;
};
